import type { UserRole } from "@teamz/common";

import ClubIcon from "@/assets/club.svg";
import PlayerIcon from "@/assets/player.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { routes } from "@/routes";

export function SelectSignupRole({ onSelectRole, disabled = false }: { onSelectRole?: (role: UserRole) => void; disabled?: boolean }) {
  const { t } = useTranslation(["common"]);
  return (
    <div className="flex flex-col items-center gap-4 text-balance rounded-lg bg-neutral-200 px-9 py-8 text-center">
      <div className="flex flex-col items-center gap-1">
        <span className="font-bold text-black">
          {t(onSelectRole ? "auth.complete-account" : "auth.create-account")}
        </span>
        <span className="text-xs text-neutral-500">
          {t("auth.account-type")}
        </span>
      </div>

      <div className="flex w-full flex-col gap-2">
        {(["club", "player"] as const).map((role) => {
          const Icon = role === "club" ? ClubIcon : PlayerIcon;
          const content = (
            <div className="flex flex-col items-center gap-0.5 rounded bg-white py-4 text-black shadow">
              <Icon className="size-8 text-orange-500" />
              <span className="text-sm font-bold">{t(role === "club" ? "auth.club" : "auth.player")}</span>
              <span className="text-xs text-neutral-600">{t(role === "club" ? "auth.club-helper" : "auth.player-helper")}</span>
            </div>
          );
          return onSelectRole
            ? <button className="disabled:opacity-50" disabled={disabled} key={role} onClick={() => onSelectRole(role)} type="button">{content}</button>
            : <Link key={role} to={role === "club" ? routes.signupClub : routes.signupPlayer}>{content}</Link>;
        })}
      </div>

      {!onSelectRole && (
        <div>
          <span className="text-xs text-neutral-500">
            {t("auth.already-account")}
            {" "}
            <Link to={routes.signin} className="font-bold">
              {t("auth.login")}
            </Link>
          </span>
        </div>
      )}
    </div>
  );
}
